import { getCookieWithKey } from 'src/cookies';
import { userHasConsentedToAnalyticsCookieCategory } from 'src/cookies/cookie-types/analytical-cookies';
import { userHasConsentedToMarketingCookieCategory } from 'src/cookies/cookie-types/marketing-cookies';
import { userHasConsentedToPreferencesCookieCategory } from 'src/cookies/cookie-types/preference-cookies';
import { userHasConsentedToSocialMediaCookieCategory } from 'src/cookies/cookie-types/social-media-cookies';

import { necessaryConsentCookieCategoryKey } from './cookie-types/necessary-cookies';

export const COOKIE_CONSENT_COOKIE_NAME = 'CookieControl';
export const COOKIE_CATEGORY_CONSENT_ACCEPTED_VALUE = 'accepted';

export const userHasConsentedToCookieCategoryWithKey = (cookieCategoryKey: string): boolean => {
  if (cookieCategoryKey === necessaryConsentCookieCategoryKey) {
    return true;
  }

  const consentCookieValue = getCookieWithKey(
    COOKIE_CONSENT_COOKIE_NAME,
    cookieCategoryKey
  ).getValue();

  if (!consentCookieValue) {
    return false;
  }
  const parsedConsentCookieValue = JSON.parse(consentCookieValue) as {
    optionalCookies: Record<string, string>;
  };
  return (
    parsedConsentCookieValue.optionalCookies[cookieCategoryKey] ===
    COOKIE_CATEGORY_CONSENT_ACCEPTED_VALUE
  );
};

export const userHasConsentedToAllOptionalCookieCategories = (): boolean =>
  userHasConsentedToAnalyticsCookieCategory() &&
  userHasConsentedToPreferencesCookieCategory() &&
  userHasConsentedToMarketingCookieCategory() &&
  userHasConsentedToSocialMediaCookieCategory();
